import { render, staticRenderFns } from "./UploadPrintableModal.vue?vue&type=template&id=48dbd46f&scoped=true&"
import script from "./UploadPrintableModal.vue?vue&type=script&lang=js&"
export * from "./UploadPrintableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dbd46f",
  null
  
)

export default component.exports